export default "<app-global-loading></app-global-loading>\n<app-alert></app-alert>\n<router-outlet></router-outlet>\n"